var $ = require('./zepto');

require('./event');
require('./ajax');
require('./form');
require('./ie');

module.exports = $;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_zepto-modules@1.0.1@zepto-modules/_default.js
// module id = 137
// module chunks = 0